import { Grid, CssBaseline } from "@mui/material";
import CalebAndBrownLogo from "src/icons/cnbDesktop";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import CnbLogoMobile from "src/icons/CnbLogoMobile";
import { LoginStyles } from "src/components/auth/styles/Login.styles";
import GenericMessageModal from "src/components/wallets/Modal/Withdraw/GenericMessageModal";

export default function RequestForm() {
  const classes = LoginStyles();
  const isMobile = useIsMobile();
  const message =
    "If you don’t receive a reset password email within 5 minutes please contact us at support@calebandbrown.com and let us know you're trying to reset your password. Please note your reset link will expire 30 minutes after you’ve received it.";

  return (
    <div className={classes.container}>
      <CssBaseline />
      <Grid container className={classes.logoBox}>
        {isMobile ? <CnbLogoMobile height={"200px"} /> : <CalebAndBrownLogo />}
      </Grid>
      <Grid container justifyContent="center" style={{ zIndex: 10000 }}>
        <GenericMessageModal customMessage={message} hideButton halfSize />
      </Grid>
    </div>
  );
}
